import { MediaType } from "@/types/mediaArtifact";

export const getClosestDurationOption = (
  targetDuration: number,
  options: number[]
) => {
  if (!options.length) {
    return null;
  }

  return options.reduce((closest, option) => {
    const currentDiff = Math.abs(option - targetDuration);
    const bestDiff = Math.abs(closest - targetDuration);

    if (currentDiff < bestDiff) {
      return option;
    }

    return closest;
  }, options[0]);
};

interface CalculateCreditParams {
  baseCredit: number;
  count: number;
  mediaType: MediaType;
  shotDuration?: number;
  durationOptions?: number[] | null;
  unitType?: "videos" | "seconds";
}

export const calculateCredit = ({
  baseCredit,
  count,
  mediaType,
  shotDuration,
  durationOptions,
  unitType,
}: CalculateCreditParams) => {
  if (baseCredit <= 0 || count <= 0) {
    return 0;
  }

  let totalCredit = baseCredit * count;

  const isVideoLike = mediaType === "video" || mediaType === "avatar";
  // 只有当 unitType 为 "seconds" 时才按时长计费
  if (
    isVideoLike &&
    unitType === "seconds" &&
    typeof shotDuration === "number"
  ) {
    const normalizedOptions = Array.isArray(durationOptions)
      ? durationOptions.filter((option) => typeof option === "number")
      : null;

    const durationMultiplier = normalizedOptions?.length
      ? getClosestDurationOption(shotDuration, normalizedOptions)
      : Math.round(shotDuration);

    if (durationMultiplier != null) {
      totalCredit *= durationMultiplier;
    }
  }

  return totalCredit;
};
